import { HardwareDetailType } from 'hardware/types'
import getHardwareDetailFromSystem from 'hardware/utils/getHardwareDetailFromSystem'
import _ from 'lodash'
import useExistingSystem from 'projectSections/sections/energy/Retrofit/useExistingSystem'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useStudioSignalsLazy } from 'Studio/signals/useStudioSignalsLazy'
import { StudioSystemType } from 'types/global'

const defaultHardwareDetails = []

const useHardwareDetailsDynamic = (): HardwareDetailType[] => {
  const [hardwareDetails, setHardwareDetails] = useState<HardwareDetailType[]>(() =>
    window.editor?.selectedSystem
      ? getHardwareDetailFromSystem({ system: window.editor.selectedSystem })
      : defaultHardwareDetails
  )
  const existingSystem = useExistingSystem()
  const existingSystemRef = useRef(existingSystem)
  existingSystemRef.current = existingSystem

  const hardwareDetailsRef = useRef<HardwareDetailType[]>()
  hardwareDetailsRef.current = hardwareDetails

  const updateBomDetailsForSystem = useCallback((system: StudioSystemType) => {
    if (!system) return
    const referenceSystem = existingSystemRef.current?.uuid !== system.uuid ? existingSystemRef.current : undefined
    const newHardwareDetails = getHardwareDetailFromSystem({ system, referenceSystem })
    if (!_.isEqual(hardwareDetailsRef.current, newHardwareDetails)) {
      setHardwareDetails(newHardwareDetails)
    }
  }, [])

  useEffect(() => {
    updateBomDetailsForSystem(window.editor?.selectedSystem)
  }, [existingSystem])

  const onFreshState = useCallback((object) => {
    if (!object) {
      return
    }
    if (
      object.type !== 'OsSystem' &&
      object.type !== 'OsInverter' &&
      object.type !== 'OsBattery' &&
      object.type !== 'OsOther' &&
      object.type !== 'OsModule' &&
      object.type !== 'OsModuleGrid'
    ) {
      return
    }
    updateBomDetailsForSystem(window.editor?.selectedSystem)
  }, [])

  useStudioSignalsLazy(
    onFreshState,
    ['objectChanged', 'objectAdded', 'objectRemoved', 'objectSelected', 'systemSelected'],
    undefined,
    { debounce: 1 }
  )
  return hardwareDetails
}

export default useHardwareDetailsDynamic
